import React from "react";
import { progressColor } from "../../utils/assessmentHelpers";

/**
 * Sub-header bar shown inside the Assessment page.
 * Contains: back button, live progress bar, selected type + tool name.
 *
 * Props:
 *   selectedType  {string}
 *   toolName      {string}
 *   completion    {number} 0-100
 *   onBack        {Function}
 */
const AssessmentSubHeader = ({ selectedType, toolName, completion, onBack }) => {
  const color = progressColor(completion);

  return (
    <div
      style={{
        background: "white",
        // borderBottom: "1px solid #eee",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px",
        width:'90%',
        margin: "0 auto",
        flexWrap: "wrap",
        gap: "10px",
      }}
    >
      {/* Back */}
      <button
        onClick={onBack}
        style={{
          background: "white",
          border: "1px solid #ccc",
          borderRadius: "6px",
          padding: "7px 16px",
          cursor: "pointer",
          fontSize: "13px",
          color: "#333",
          fontWeight: "500",
        }}
      >
        ← MA DASHBOARD
      </button>

      <div style={{ display: "flex", alignItems: "center", gap: "18px", flexWrap: "wrap" }}>
        {/* Live progress */}
        {/* <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px" }}>
          <span style={{ color: "#555" }}>Completion:</span>
          <div
            style={{
              width: "110px",
              background: "#e5e7eb",
              borderRadius: "99px",
              height: "8px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${completion}%`,
                height: "100%",
                background: color,
                borderRadius: "99px",
                transition: "width 0.35s ease",
              }}
            />
          </div>
          <span style={{ fontWeight: "800", color }}>{completion}%</span>
        </div> */}

        {/* Meta pill */}
        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: "6px",
            padding: "7px 16px",
            fontSize: "13px",
            background: "#fafafa",
          }}
        >
          Selected Type:{" "}
          <span style={{ color: "#bb1ccc", fontWeight: "700" }}>{selectedType}</span>
          &nbsp;&nbsp; Tool Name:{" "}
          <span style={{ color: "#bb1ccc", fontWeight: "700" }}>{toolName}</span>
        </div>
      </div>
    </div>
  );
};

export default AssessmentSubHeader;
